import Slider from 'react-slick';
import { StripItem } from './StripItem';
import { twMerge } from 'tailwind-merge';
import { LogoPanel } from '../../LogoPanel';
import { StripFragment } from '@/utils/dato/generated';
import { useWindowWidth } from '@/utils/hooks/useWindowWidth';

const Strip = ({ elements: rawElements, variant }: StripFragment) => {
  const elements = rawElements ?? [];
  const windowWidth = useWindowWidth();

  if (!elements.length) {
    return null;
  }

  if (variant === 'logo-panel') {
    return <LogoPanel elements={elements} />;
  }

  if (windowWidth === undefined) {
    return null;
  }

  const isMobile = windowWidth < 768;
  const itemClass = twMerge(
    'strip-items flex flex-wrap items-center lg:items-start w-full justify-center gap-6',
    variant ? `strip--${variant}` : undefined,
  );

  if (!isMobile) {
    return (
      <div className={itemClass}>
        {elements.map(({ id, ...rest }) => (
          <StripItem stripVariant={variant} key={id} id={id} {...rest} />
        ))}
      </div>
    );
  }

  return (
    <Slider
      className={twMerge('strip-items', variant ? `strip--${variant}` : undefined)}
      autoplaySpeed={1500}
      slidesToScroll={1}
      slidesToShow={1}
      autoplay={true}
      infinite={true}
      arrows={false}
      dots={false}
    >
      {elements.map(({ id, ...rest }) => (
        <StripItem stripVariant={variant} key={id} id={id} {...rest} />
      ))}
    </Slider>
  );
};

export default Strip;
